import { render } from "./CustomizableCloseButton.vue?vue&type=template&id=b30665cc"
import script from "./CustomizableCloseButton.vue?vue&type=script&lang=js"
export * from "./CustomizableCloseButton.vue?vue&type=script&lang=js"
script.render = render

export default script